import { render } from "./SearchPromotionCategoryItem.vue?vue&type=template&id=6254da4d&scoped=true"
import script from "./SearchPromotionCategoryItem.vue?vue&type=script&lang=js"
export * from "./SearchPromotionCategoryItem.vue?vue&type=script&lang=js"

import "./SearchPromotionCategoryItem.vue?vue&type=style&index=0&id=6254da4d&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6254da4d"]])

export default __exports__